import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { AuthModule } from '../auth/auth.module';
import { MerchantController } from './merchant.controller';
import { MerchantService } from './merchant.service';
import { StoreProvisioningService } from './store-provisioning.service';

@Module({
  imports: [AuthModule],
  controllers: [MerchantController],
  providers: [PrismaService, MerchantService, StoreProvisioningService],
  exports: [MerchantService, StoreProvisioningService],
})
export class MerchantModule {}
